module.exports = __webpack_public_path__ + "img/aj-aibo.e750311a.jpg";